import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { AccordionGeneralityForm as GeneralityVM } from 'shell/view-models/accordion-generality-form';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';

export const transformGenerality = (person: SubjectData): GeneralityVM | null => {
  const birthChoiceDate = transformToChoiceDate(
    person?.generalita?.senzaGiorno || '',
    person?.generalita?.senzaGiornoMese || ''
  );

  const originReturnData: GeneralityVM | null = person?.generalita
    ? {
        fiscalCode: person.generalita.codiceFiscale?.codFiscale || '',
        surname: person.generalita.cognome || '',
        withoutName: person?.generalita?.senzaNome === '1' ? true : false,
        withoutSurname: person?.generalita?.senzaCognome === '1' ? true : false,
        name: person.generalita.nome || '',
        aire: person.generalita?.soggettoAIRE || 'N',
        validityFiscalCode: person.generalita?.codiceFiscale?.descrizioneValiditaCF || '',
        validityFiscalCodeId: person.generalita?.codiceFiscale?.validitaCF || '',
        validityDateFiscalCode: person.generalita?.codiceFiscale?.dataAttribuzioneValidita
          ? DateTime.fromISO(person.generalita?.codiceFiscale?.dataAttribuzioneValidita)
          : null,
        gender: person.generalita?.sesso || '',
        expatriationYear: person.generalita?.annoEspatrio || '',
        birthDate: person.generalita?.dataNascita
          ? DateTime.fromISO(person.generalita?.dataNascita)
          : null,
        // senza giorno mese, etc
        birthChoiceDate,
        // generality italian form
        italian: person.generalita?.luogoNascita?.comune
          ? {
              location: person.generalita?.luogoNascita?.comune?.descrizioneLocalita || '',
              province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
              municipality: person.generalita?.luogoNascita?.comune?.codiceIstat
                ? {
                    id: person.generalita?.luogoNascita?.comune?.codiceIstat || '',
                    description: person.generalita?.luogoNascita?.comune?.nomeComune || '',
                    province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
                  }
                : null,
            }
          : undefined,
        // generality foreign form
        foreign: person.generalita?.luogoNascita?.localita
          ? {
              state: person.generalita?.luogoNascita?.localita?.codiceStato
                ? {
                    id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                    value: person.generalita?.luogoNascita?.localita?.descrizioneStato || '',
                    province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
                  }
                : null,
              province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
              municipality: person.generalita?.luogoNascita?.localita?.codiceStato
                ? {
                    id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                    description:
                      person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
                    province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
                  }
                : null,
            }
          : undefined,
        isForeign: person.generalita?.luogoNascita?.localita ? true : false,
        // Other fields generality
        exceptionalBirthPlace: person.generalita?.luogoNascita?.luogoEccezionale || '',
        municipalityIdentifier: person.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
        istatCode: person.generalita?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat || '',
        anprIdentifier: person.generalita?.idSchedaSoggettoANPR || '',
        note: person.generalita?.note || '',
        anprUniqueIdentifier: person.identificativi?.idANPR,
      }
    : null;

  return originReturnData;
};
